import sanawarLogo from "../../img/Parallax/sanawar-logo.png";
import sanawarBg from "../../img/Parallax/form-bg.jpg";
import RegistrationClosed from "./RegistrationClosed";

export default function TourRegistrationFormClosed() {
  return (
    <div
      className="w-full text-black-1 min-h-screen bg-white-1 rounded-lg shadow-lg relative"
      style={{
        backgroundImage: `url(${sanawarBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Logo (Non-sticky on mobile, appears above progress bar) */}
      <div className="w-full flex justify-center items-center bg-white-1 py-2 md:hidden">
        <img src={sanawarLogo} alt="Website Logo" className="h-14 w-auto" />
      </div>

      {/* Progress bar section (Logo for desktop view) */}
      <div className="w-full sticky top-0 left-0 bg-white-1 flex flex-col md:flex-row items-center shadow-md justify-between z-100 px-0 md:px-4">
        <div className="max-sm:hidden flex items-center">
          <img
            src={sanawarLogo}
            alt="Website Logo"
            className="h-16 w-auto md:h-20"
          />
        </div>
      </div>

      {/* 🌟 Registration Closed Box (Displayed instead of the form) */}
      <div className="w-full flex justify-center items-center mt-8 pb-8 px-4">
        <div className="w-full max-w-[650px] bg-white-1/60 backdrop-blur-md rounded-2xl shadow-2xl">
          <RegistrationClosed />
        </div>
      </div>
    </div>
  );
}
